import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DigitalDisplay from '../components/DigitalDisplay';
import './FAQ.css';

const FAQ = () => {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(null); // Manage expanded FAQ item
  const [copied, setCopied] = useState(false);
  const [showCloseHint, setShowCloseHint] = useState(false); // For follow-up hint

  const handleCopy = (event, index) => {
    event.stopPropagation(); // Prevent toggling FAQ when copying
    navigator.clipboard.writeText(
        '4UTEFQjNMvfQF5NT8mVfXdMAKoL7hS7i9U4mMVAzpump'
    );
    setCopied(true);
    setShowCloseHint(false); // Reset the hint while copying

    // Show the follow-up message after 2 seconds
    setTimeout(() => {
        setShowCloseHint(true);
    }, 2000);

    // Close FAQ item on next click anywhere in the FAQ item
    setTimeout(() => {
        setExpandedIndex(null);
        setCopied(false);
        setShowCloseHint(false);
    }, 4000);
};

const toggleFAQ = (index) => {
    // Toggle FAQ item
    setExpandedIndex(expandedIndex === index ? null : index);

    // Reset hint and "Copied!" message on toggle
    setShowCloseHint(false);
    setCopied(false);
};

    const faqs = [
        {
            question: 'What is $1?',
            icon: '/assets/icons/1-meme-coin-01-what-is-1-dollar-token.png',
            answer: (
                <>
                    <img
                        src='/assets/images/solana_1_dollar_stable_memecoin_270x248px.png'
                        alt='$1 Logo'
                        className='inline-logo'
                        style={{ width: '50px', height: 'auto' }}
                    />{' '}
                    is the first stable memecoin on the Solana blockchain, blending
                    gamified engagement with real-world financial stability.
                </>
            ),
        },
        {
			question: 'What’s the contract address?',
			icon: '/assets/icons/1-meme-coin-02-contract-address.png',
			answer: (
				<>
					<p>$1 contract address:</p>
					<button
						className='contract-button'
						onClick={(event) => handleCopy(event)}>
						4UTEFQjNMvfQF5NT8m
						<br />
						VfXdMAKoL7hS7i9U
						<br />
						4mMVAzpump
					</button>
					<div
						className='copy-wrapper'
						onClick={(event) => handleCopy(event)}>
						<img
							src='/assets/icons/copy-icon.png'
							alt='Copy Icon'
							className='copy-icon'
						/>
						<span>
							{copied ? (
								<>
									Copied!{' '}
									{showCloseHint && (
										<em style={{ fontStyle: 'italic' }}>
											{' '}
											- (click to close)
										</em>
									)}
								</>
							) : (
								'Click to copy contract address'
							)}
						</span>
					</div>
				</>
			),
		},
        {
            question: 'Where can I buy $1?',
            icon: '/assets/icons/1-meme-coin-03-where-to-buy-one-dollar-token.png',
            answer: (
                <>
                    You can purchase $1 on{' '}
                    <a
                        href='https://raydium.io/swap/?utm_source=utm_medium%3Dlist&inputMint=sol&outputMint=4UTEFQjNMvfQF5NT8mVfXdMAKoL7hS7i9U4mMVAzpump'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='raydium-link'>
                        Raydium
                    </a>
                    , a decentralized exchange (DEX) on the Solana blockchain.
                </>
            ),
        },
        {
            question: 'Where is the $1 Community located?',
            icon: '/assets/icons/1-meme-coin-04-where-can-I-find-1-Community-Telegram-Solana.png',
            answer: (
                <>
                    Join our growing community on Telegram, X (formerly Twitter), and
                    Discord. Find the links in the{' '}
                    <a href='/about' className='about-link'>
                        About page
                    </a>
                    .
                </>
            ),
        },
        {
            question: 'What makes $1 different from other memecoins?',
            icon: '/assets/icons/1-meme-coin-05-what-makes-1-token-different.png',
            answer: (
                <>
                    Unlike most memecoins, $1 is committed to creating real-world
                    stability through its gamified ecosystem and unique burning
                    mechanisms. It's what would happen if stable coins were actually
                    born in web 3. We're the first of our kind.
                </>
            ),
        },
        {
            question: 'What is the $1 Odyssey?',
            icon: '/assets/icons/1-meme-coin-06-What-is-the-1-Odyssey_.png',
            answer: (
                <>
                    The $1 Odyssey is a gamified universe where the real-world
                    economy meets an immersive narrative-driven experience. Build,
                    stake, and earn while shaping your story.
                </>
            ),
        },
        {
            question: 'Will there be NFTs?',
            icon: '/assets/icons/1-meme-coin-07-Will-there-be-NFTs.png',
            answer: (
                <>
                    Yes! The $1 Odyssey will feature NFTs as part of its gamification
                    and storytelling elements. Stay tuned for future drops.
                </>
            ),
        },
        {
            question: 'What are $1’s future plans?',
            icon: "/assets/icons/1-meme-coin-08-what-is-1-dollar's-future-plans.png",
            answer: (
                <>
                    Our roadmap includes staking, NFT integration, and a fully
                    gamified ecosystem where players can earn and participate in the
                    economy.
                </>
            ),
        },
        {
            question: 'Is $1 deflationary?',
            icon: '/assets/icons/1-meme-coin-09-what-makes-1-dollar-token-deflationary.png',
            answer: (
                <>
                    It's currently capped, at just under 1 Billion tokens, so no more
                    will be minted. Ultimately, though: Yes, $1 will employ unique
                    burning mechanisms to ensure a controlled supply and enhance
                    value over time.
                </>
            ),
        },
        {
            question: 'What makes $1 fun?',
            icon: '/assets/icons/1-meme-coin-10-what-makes-1-dollar-token-fun.png',
            answer: (
                <>
                    It’s a blend of financial potential, community engagement, and
                    immersive gameplay. Plus, it’s built with the fun, simplistic
                    idea to make $1 = $1 and so, yeah: we literally have 'fun' at its
                    core.
                </>
            ),
        },
    ];

    return (
        <div className='page-container'>
            <DigitalDisplay>
                {/* FAQ Header */}
                <div className='faq-header'>
                    <img
                        src='/assets/icons/1-meme-coin-001-blockchain-tech.png'
                        alt='FAQ Icon'
                        className='faq-header-icon'
                    />
                    <h1>FAQ</h1>
                </div>

                {/* FAQ Content */}
                <div className='faq-content'>
                    {faqs.map((item, index) => (
                        <div
                            className={`faq-item ${
                                expandedIndex === index ? 'active' : ''
                            }`}
                            key={index}
                            onClick={() => toggleFAQ(index)}>
                            <h2>
                                <img src={item.icon} alt='FAQ Icon' className='faq-icon' />
                                {item.question}
                            </h2>
                            <div
                                className={`faq-answer ${
                                    expandedIndex === index ? 'expanded' : ''
                                }`}
                                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
                            >
                                {item.answer}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Navigation Buttons */}
                <div className='choice-button-container'>
                    <button
                        className='choice-button'
                        onClick={() => navigate('/about')}>
                        Back to About
                    </button>
                    <button
                        className='choice-button'
                        onClick={() => navigate('/roadmap')}>
                        Forward to Roadmap
                    </button>
                </div>
            </DigitalDisplay>
        </div>
    );
};

export default FAQ;
